export const SMALL = 'SMALL';
export const EXTRA_SMALL = 'EXTRA_SMALL';
export const MEDIUM = 'MEDIUM';
export const SEMI_LARGE = 'SEMI_LARGE';
export const LARGE = 'LARGE';
export const XLARGE = 'XLARGE';

export const DISABLED = 'DISABLED';
export const PRIMARY = 'PRIMARY';
export const SECONDARY = 'SECONDARY';

export const GRID_VIEW = 'GRID_VIEW';
export const LIST_VIEW = 'LIST_VIEW';
export const LIST = 'list';
export const GRID = 'grid';

export const ADD_TO_CART = 'Add to Cart';
export const ADDING_TO_CART = 'Adding';
export const ADDED_TO_CART = 'Added to cart!';
export const SEE_DETAILS = 'See Details';
export const ADD_TO_COMPARE = 'Add to Compare';
export const BUY_NOW = 'Buy Now';
export const NOT_AVAILABLE_ONLINE = 'Not Available Online';
export const NOTIFY_ME = 'Notify Me';
export const ADD_TO_WISHLIST = 'Add to Wishlist';
export const PLACE_ORDER = 'Place Order';

export const RED_HOT = '#DB0032';
export const WHITE = '#FFFFFF';
export const SENATE = '#49525E';
export const TITAN_WHITE = '#E9F1FF';

export const DETAILS = 'details';
export const SPECIFICATION = 'specification';
export const DELIVERY_WARRANTY = 'delivery & warranty';

export const ALLOW_THIS_TIME = 'allow_this_time';
export const ALLOW_ON_EVERY_VISIT = 'allow_on_every_visit';
export const NEVER_ALLOW = 'never_allow';

export const PRODUCTS_PAGE = '/products';

export const OTP_MAX_RETRY_COUNT = 3;
export const OTP_MAX_RESEND_COUNT = 3;

export const EMAIL = 'email';
export const PHONE = 'phone';

export const DEFAULT_COUNTRY_CODE = '+880';

export const CATEGORY_INFO_DATA_KEY = 'category_info_data';

export const ONLINE = 'online';
export const COD = 'cash_on_delivery';
export const ONLINE_EMI = 'online_emi';

export const PROMO_CODE = 'promo_code';
export const MAX_PRODUCT_COMPARISON = 3;

export const DEFAULT_NUM_OF_PRODUCT_RATTING =
  process.env.DEFAULT_NUM_OF_PRODUCT_RATTING || 5;

export const OTP_LENGTH = 6;

export const API_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const TEXT_COLOR_MODE = {
  light: '#fff',
  dark: '#fff',
};

export const LOGIN_ERROR_MESSAGE = {
  WRONG_OTP: 'wrong-otp',
  LAST_ATTEMPT: 'last-attempt',
  LAST_RESEND_ATTEMPT: 'last-resend-attempt',
};

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
};

export const DEFAULT_LANGUAGE = 'en';
export const REDIRECT_AFTER_LOGOUT = [
  '/my-profile',
  '/my-singer',
  '/my-orders',
  '/address',
  '/order-processing',
];

export const IMAGE = 'image';

export const GOOGLE_MAP_ZOOM = 15;

export const STORE_TYPE = {
  HOME_APPLIENCES: 'Home appliances',
  APPLIANCE_STORE: 'Appliance store',
};

export const STOCK_TYPE = {
  LIMITED_STOCK: { id: 'Limited Stock!', color: '#E94D31' },
  IN_STOCK: { id: 'In Stock!', color: '#39AA70' },
  OUT_OF_STOCK: { id: 'Out of Stock', color: '#BF002A' },
};

export const DEFAULT_POPUPS_TIMER = 4000;

export const TIMER = {
  DEFAULT_MODAL_TIMER: 5000,
};

export const DEFAULT_META_TITLE = 'Singer Bangladesh Limited';

export const DEFAULT_PLACEHOLDER_IMAGE = '/icons/no-image-icon.png';

export const currentCurrency = '৳';
export const percentageSymbol = '%';
export const ORDER_PRODUCT_IMAGE_VISIBLE = 4;

export const CART_PAGE_EMI_PROMOTIONAL_TEXT =
  'Enjoy 0% EMI on orders above ৳ 10,000!';

export const DEFAULT_LOCALE_COOKIE_NAME = 'NEXT_LOCALE';

export const PRODUCT_LIST_MAX_COUNT = 3;

export const CAPACITY = 'capacity';

export const YOUTUBE_VIDEO = 'youtube-video';
export const WEB = 'web';

export const EXTERNAL = 'external';

export const FRONTEND_API_TIMEOUT_MS = 30000;

export const SLEEP_TIME_API = 1000;

export const MESSENGER_BASE_URL = 'https://m.me/';

export const WHATSAPP_BASE_URL = 'https://web.whatsapp.com/send?phone=';

export const WHATSAPP_BASE_URL_MOBILE = 'https://wa.me/';
export const INITIAL_NUMBER_OF_VISIBLE_OFFER = 3;

export const APPLY = 'apply';

export const SWIPE = 'swipe';

export const SPIN_DURATION_MS = 8000;
export const WHEEL_POS_RESET_DURATION_MS = 3000;
export const FAKE_SPIN_DURATION_MS = 8000;
export const SPIN_COUNT = 360 * 8; // 360 deg * count

export const TOTAL_RATING = 5;

export const CAMPAIGN_LANDING = '/campaign-landing';
